export const BG_IMAGES = {
  trading: "https://static.prod-images.emergentagent.com/jobs/f1709a2f-c779-4c95-b97b-a79ff3440ce0/images/a9f4af350c463062f19cf1a7c57a6752c0360e819dd8996f15d5bb2eca92b682.jpeg",
  crypto: "https://static.prod-images.emergentagent.com/jobs/f1709a2f-c779-4c95-b97b-a79ff3440ce0/images/8e7405cdbe0d5301fb53cb07e6b4a4d11f42403f546925b4a1e20795ab990a27.jpeg",
  gold: "https://static.prod-images.emergentagent.com/jobs/f1709a2f-c779-4c95-b97b-a79ff3440ce0/images/a9f4af350c463062f19cf1a7c57a6752c0360e819dd8996f15d5bb2eca92b682.jpeg",
  charts: "https://static.prod-images.emergentagent.com/jobs/f1709a2f-c779-4c95-b97b-a79ff3440ce0/images/8e7405cdbe0d5301fb53cb07e6b4a4d11f42403f546925b4a1e20795ab990a27.jpeg",
};

export default function SectionBg({ type = "trading" }) {
  return (
    <div className="section-bg" aria-hidden="true">
      <div className="section-bg-img" style={{ backgroundImage: `url(${BG_IMAGES[type] || BG_IMAGES.trading})` }} />
    </div>
  );
}
